import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"

import { loopArrayIndex } from "@utils/functions"

const InfoCarousel = ({ info1Data, imageClick = (x) => null }) => {
  const swiperRef = useRef(null)
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0)

  function arrowClick(dir) {
    const index = loopArrayIndex(dir, info1Data?.block, currentInfoIndex)
    setCurrentInfoIndex(index)
    swiperRef.current.slideTo(index)
  }
  return (
    <Wrapper>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="fade"
        className="bgImage"
        spaceBetween={0}
        slidesPerView={1}
        centeredSlides={true}
        onSlideChange={(_swiper) => setCurrentInfoIndex(_swiper.activeIndex)}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade]}
        speed={800}
        style={{ height: "100%", width: "100%" }}
        loop
      >
        {info1Data?.block.map((content, index) => (
          <SwiperSlide
            key={content?.img?.publicURL + index?.toString()}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              alt={content?.content?.filename}
              src={content?.img?.publicURL}
              onClick={() => {
                imageClick(content)
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="shadow"></div>
      <div className="copy">
        <div className="mainText">
          <div className="headline">
            {info1Data?.block[currentInfoIndex]?.headline
              .split(" ")
              .map((word, index) => (
                <span key={index} className={index === 0 ? "styled" : ""}>
                  {word} {index === 0 && <br />}{" "}
                </span>
              ))}
          </div>
          <div className="body">{info1Data?.block[currentInfoIndex]?.body}</div>
        </div>
      </div>
      <div className="controls">
        <div className="button">
          <div
            onClick={() => {
              arrowClick(false)
            }}
          >
            {" "}
            <img src="/assets/icons/back.svg" alt="" />
          </div>
          <div
            onClick={() => {
              arrowClick(true)
            }}
          >
            <img
              src="/assets/icons/back.svg"
              style={{ transform: "rotate(180deg)" }}
              alt=""
            />
          </div>
        </div>
        {/* <div className="timeline">
          {info1Data?.block?.map((headline, index) => (
            <div
              onClick={() => {
                setCurrentInfoIndex(index), swiperRef.current.slideTo(index)
              }}
              className={index === currentInfoIndex ? "active" : ""}
            >
              {headline.headline}
            </div>
          ))}
        </div> */}
        <div className="index">
          {currentInfoIndex + 1}/{info1Data?.block?.length}
        </div>
      </div>
    </Wrapper>
  )
}

export default InfoCarousel

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: PrimaryFont;

  .shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    opacity: 0.8;
    backdrop-filter: blur(3px);
    pointer-events: none;
    mask-size: 100%;
    mask-repeat: no-repeat;
    mask: radial-gradient(
      circle at 0% 100%,
      rgba(0, 0, 0, 1) 5%,
      rgba(0, 0, 0, 0) 50%
    );
  }

  .bgImage {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .copy {
    height: 85%;
    display: flex;
    align-items: center;
    color: #ffffff;
    z-index: 1;
    pointer-events: none;
    padding: 0 8rem;
    
    .mainText {
      margin-top: auto;
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      .headline {
        width: 100%;
        font-size: 4rem;
        line-height: 55px;
        font-family: PrimaryFont;
        
        .styled {
          display: block;
          line-height: 6rem;
          font-size: 6rem;
          font-family: SecondaryFont;
          font-weight: 100;
        }
      }
      
      .body {
        font-family: PrimaryFont;
        font-size: 1.25rem;
        line-height: 25px;
        width: 75%;
        font-weight: 100;
      }
    }
  }
  
  .controls {
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 5rem;
    z-index: 1;
    padding: 2rem 8rem;
    
    .button {
      display: flex;
      gap: 1rem;
      cursor: pointer;
      z-index: 5;
      
      div {
        background-color: var(--primary);
        padding: 1rem;
        color: #fff;
        width: 4rem;
        height: 4rem;
        border-radius: 2rem;
        img {
          width: 100%;
          height: 100%;
          padding: 0.5rem;
        }
        &:active {
          opacity: 0.75;
          transform: scale(0.95);
          transition: 0.3s;
        }
      }
    }
    
    .timeline {
      display: flex;
      color: #ffffff73;
      gap: 2rem;
      transition: 0.3s;
      cursor: pointer;
      
      .active {
        color: white;
        transition: 0.3s;
      }
    }
    
    .index {
      font-size: 2rem;
      color: white;
      letter-spacing: 5px;
    }
  }
`
